export type NavItem = {
  label: string
  to: string
}

export const navItems: NavItem[] = [
  { label: 'Les cours', to: '/les-cours' },
  { label: 'En salle', to: '/cours-en-salle' },
  { label: 'En ligne', to: '/cours-en-ligne' },
  { label: 'Tarifs', to: '/tarifs' },
  { label: 'Actualités', to: '/actualites' },
]

export type Discipline = {
  name: string
  tagline: string
  description: string
  details: string[]
}

export const disciplines: Discipline[] = [
  {
    name: 'Pilates',
    tagline: 'Construire la force profonde',
    description:
      "Un travail précis du centre du corps, de la respiration et de l'alignement. Sur tapis ou avec petit matériel, chaque exercice est adapté à votre morphologie et à votre histoire corporelle.",
    details: ['Sur tapis', 'Avec petit matériel', 'Individuel ou petit groupe'],
  },
  {
    name: 'Stretching Postural®',
    tagline: 'Délier, redresser, respirer',
    description:
      "La méthode Jean-Pierre Moreau : des postures tenues, un étirement actif et une respiration guidée pour libérer les tensions installées et retrouver de la hauteur. Praticienne certifiée SP3.",
    details: ['Postures tenues', 'Respiration guidée', 'Méthode certifiée SP3'],
  },
  {
    name: 'Munz Floor®',
    tagline: 'Relâcher le système nerveux',
    description:
      "Un travail au sol, lent et sensoriel, qui agit sur les fascias et le tonus de fond. Idéal lorsque le corps est fatigué, stressé ou verrouillé. Coach certifiée Munz Floor®.",
    details: ['Travail au sol', 'Fascias et tonus', 'Coach certifiée'],
  },
]

export type Format = {
  title: string
  eyebrow: string
  description: string
  points: string[]
  to: string
  image: string
  imageAlt: string
}

export const formats: Format[] = [
  {
    eyebrow: 'Au studio',
    title: 'Les cours en salle',
    description:
      "En petit groupe ou en individuel, avec un regard posé sur vous à chaque séance : corrections manuelles, variantes et progressions sur mesure.",
    points: ['Groupes de 8 personnes maximum', 'Cours individuels sur rendez-vous', 'Premier cours d’essai offert'],
    to: '/cours-en-salle',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/1f13b74a-5342-4e2b-83b4-97e0ae856d5a.jpg',
    imageAlt: 'Cours de Pilates en petit groupe dans un studio lumineux',
  },
  {
    eyebrow: 'Depuis chez vous',
    title: 'Les cours en ligne',
    description:
      "Les mêmes méthodes, en visio ou en vidéo à revoir quand vous voulez. Pour garder une pratique régulière, même en déplacement ou après un déménagement.",
    points: ['Séances en direct en visio', 'Replays disponibles 30 jours', 'Programmes courts de 20 minutes'],
    to: '/cours-en-ligne',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7a63de14-8339-4d38-a828-ea1ce38e035d.jpg',
    imageAlt: 'Tapis et ordinateur installés dans un salon pour un cours en ligne',
  },
]

export const contact = {
  email: 'contact@christine-velluet.com',
  phone: '06 12 34 56 78',
  address: 'Studio — 12 rue des Lices, Angers',
  hours: ['Lundi – vendredi : 9h – 20h', 'Samedi : 9h – 12h'],
}
